import { TextField } from '@mui/material';

export const headerFilterTextFieldSx = {
  bgcolor: '#fff',
  '& .MuiInputBase-root': { minHeight: 36, height: 36, fontSize: '0.875rem' },
  '& .MuiInputLabel-root': { fontSize: 12 },
};

type HeaderFilterTextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const HeaderFilterTextField = ({ label, value, onChange, placeholder }: HeaderFilterTextFieldProps) => (
  <TextField
    size="small"
    label={label}
    value={value}
    placeholder={placeholder}
    onChange={event => onChange(event.target.value)}
    sx={headerFilterTextFieldSx}
  />
);

export const buildCicAndFilter = (values: Record<string, string>): string[] => {
  const conditions = Object.entries(values)
    .map(([key, value]) => {
      const trimmed = value.trim();
      return trimmed ? `${key}:cic:${trimmed}` : null;
    })
    .filter((token): token is string => Boolean(token));
  if (conditions.length === 0) {
    return [];
  }
  const out: string[] = [conditions[0]];
  for (let i = 1; i < conditions.length; i += 1) {
    out.push('and', conditions[i]);
  }
  return out;
};
